import { useController } from 'react-hook-form';
import {
  Avatar,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  SxProps,
} from '@mui/material';
import { CheckBoxChecked, CheckBoxUnchecked } from 'Images';

interface ICustomCheckbox {
  name: string;
  label: string;
  disabled?: boolean;
  sx?: SxProps;
  sxCheckbox?: SxProps;
  onClick?: Function;
}

export const CustomCheckbox = (props: ICustomCheckbox) => {
  const {
    field: { value, ...rest },
    fieldState: { error },
  } = useController({
    name: props.name,
    defaultValue: false,
  });

  const formError = Boolean(error);

  const checkboxClickSpecialHandler = () =>
    props.onClick ? props.onClick(props.name) : undefined;

  return (
    <FormControl error={formError}>
      <FormControlLabel
        sx={{
          fontSize: '14px',
          mb: '10px',
          '& .MuiFormControlLabel-label': { fontSize: '14px' },
          ...props.sx,
        }}
        control={
          <Checkbox
            onClick={checkboxClickSpecialHandler}
            aria-invalid={formError}
            checked={value}
            {...rest}
            disabled={props.disabled}
            sx={{
              p: '0 4px 0 9px',
              ...props.sxCheckbox,
            }}
            icon={
              <Avatar
                alt=''
                src={CheckBoxUnchecked}
                sx={{ width: '32px', height: '32px' }}
              />
            }
            checkedIcon={
              <Avatar
                alt={''}
                src={CheckBoxChecked}
                sx={{ width: '32px', height: '32px' }}
              />
            }
          />
        }
        label={props.label}
      />
      {formError && <FormHelperText>{error?.message || ''}</FormHelperText>}
    </FormControl>
  );
};
